import { LEGAL_DOCUMENTS } from "@/content/legal";
import type { PrismicLegalEntry } from "@/app/(marketing)/legal/page";

export const STATIC_LEGAL_DOCS = LEGAL_DOCUMENTS.map((doc) => ({
  slug: doc.slug,
  title: doc.title,
  description: doc.description,
  lastUpdated: doc.lastUpdated,
  category: doc.category,
}));

export function mergeWithPrismic(prismicDocs: PrismicLegalEntry[]) {
  const staticSlugs = new Set(STATIC_LEGAL_DOCS.map((d) => d.slug));
  const newFromPrismic = prismicDocs.filter((d) => !staticSlugs.has(d.slug));
  return [...STATIC_LEGAL_DOCS, ...newFromPrismic];
}

export const CATEGORY_STYLES: Record<string, { dot: string; badge: string }> = {
  Usage: { dot: "#2B72FF", badge: "rgba(43,114,255,0.12)" },
  Privacy: { dot: "#a855f7", badge: "rgba(168,85,247,0.12)" },
  Software: { dot: "var(--yellow-accent)", badge: "rgba(34,211,238,0.12)" },
  Accessibility: { dot: "var(--code-green)", badge: "rgba(91,140,255,0.12)" },
  Security: { dot: "#f97316", badge: "rgba(249,115,22,0.12)" },
};
